module.exports = "/assets/data/654ddf5bba0c70bf0d5e63f9db11152e-DG7.data.json";